import { KeyValuePair } from 'common/types/key-value-pair';

export interface ConversionPath {
  totalRevenue: number;
  totalSales: number;
  averageRevenue: number;
  averageHoursToConversion: number;
  averageMinutesToConversion: number;
  averageTouchpointsToConversion: number;
  conversionCount: number;
  chronologicalSources: string[];
  timeToConversionInSecondsValues: KeyValuePair<
    PathTimeCalculationTypes,
    number
  >[];
}

export enum PathTimeCalculationTypes {
  Mean = 'Mean',
  Median = 'Median',
  Mode = 'Mode'
}
